import type { PhlebotomyCampaignEntry } from "./phlebotomyFormUtils";

export type PhlebotomySearchEntryPath = "intake" | "sms_return" | "direct";

export type ResolvePhlebotomySearchEntryPathParams = {
  enteredThroughReminder: boolean;
  incomingTrackingId: string | null;
  campaignEntry: PhlebotomyCampaignEntry | null;
  fromPhlebotomyReminder?: boolean;
};

/** How the patient reached the finder before a location search. */
export const resolvePhlebotomySearchEntryPath = (
  params: ResolvePhlebotomySearchEntryPathParams,
): PhlebotomySearchEntryPath => {
  if (params.fromPhlebotomyReminder) {
    return "intake";
  }
  if (params.enteredThroughReminder && !params.incomingTrackingId) {
    return "intake";
  }
  if (params.incomingTrackingId || params.campaignEntry) {
    return "sms_return";
  }
  return "direct";
};
